import React from "react";

export type IconSize =
  | "xs"
  | "sm"
  | "md"
  | "lg"
  | "xl"
  | "2xl"
  | "3xl"
  | "4xl"
  | "5xl";
export type IconColor =
  | "primary"
  | "secondary"
  | "success"
  | "error"
  | "warning"
  | "info"
  | "muted"
  | "current";

export type IconWrapperProps = {
  size?: IconSize;
  color?: IconColor;
  className?: string;
  [key: string]: unknown; // Allow any additional props to be passed through
};

const sizeClasses: Record<IconSize, string> = {
  xs: "w-3 h-3",
  sm: "w-4 h-4",
  md: "w-5 h-5",
  lg: "w-6 h-6",
  xl: "w-8 h-8",
  "2xl": "w-10 h-10",
  "3xl": "w-12 h-12",
  "4xl": "w-16 h-16",
  "5xl": "w-20 h-20",
};

const colorClasses: Record<IconColor, string> = {
  primary: "text-primary",
  secondary: "text-secondary",
  success: "text-success",
  error: "text-error",
  warning: "text-warning",
  info: "text-info",
  muted: "text-muted-foreground",
  current: "text-current",
};

export function IconWrapper(
  props: IconWrapperProps & { children: React.ReactNode }
) {
  const { size, color, className, children, ...restProps } = props;
  const sizeValue = size || "md";
  const colorValue = color || "current";
  const classNameValue = className || "";

  const sizeClass = sizeClasses[sizeValue];
  const colorClass = colorClasses[colorValue];

  const child = React.Children.only(children) as React.ReactElement<{
    className?: string;
  }>;
  const existingClassName = child.props.className || "";
  const combinedClassName =
    `${sizeClass} ${colorClass} ${existingClassName} ${classNameValue}`.trim();

  return React.cloneElement(child, {
    ...child.props,
    ...restProps, // Pass through additional props like data-testid
    className: combinedClassName,
  });
}
